export default "__VITE_ASSET__DrQZn1BN__"